import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";
import { BackdropHandler } from "../../04_layout/navigation/backdropHandler";

export class Panel {
  private panelButtons: NodeListOf<HTMLElement>;
  private backdropHandler: BackdropHandler;

  constructor(private $log: Logger, private $utils: Utils) {
    this.panelButtons = document.querySelectorAll('.js-open-panel');

    this.initPanels();
  }

  public initPanels() {
    this.panelButtons?.forEach(button => {
      const openGetter = button.dataset.open;
      const panel = document.querySelector(openGetter) as HTMLElement;

      const backdrop: HTMLElement = panel.querySelector('.js-panel-backdrop');
      const backdropHandler: BackdropHandler = new BackdropHandler(backdrop, this.$log, this.$utils);

      backdropHandler.backdropActive.subscribe((active) => {
        if (!active) {
          this.closePanel(panel);
        }
      });

      this.initClosePanel(panel, backdropHandler);

      button.addEventListener('click', () => {
        this.$utils.addOrRemoveClases('add', 'open', panel);
        backdropHandler.backdropActive.next(true);
        panel?.setAttribute('aria-modal', 'true');
        panel.inert = false;
        panel?.focus();
      }, {passive: true});
    });
  }

  public initClosePanel(panel: HTMLElement, backdropHandler: BackdropHandler) {
    const panelCloseButtons = panel.querySelectorAll('.js-close-panel');

    panelCloseButtons?.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        backdropHandler.backdropActive.next(false);
      }, {passive: true});
    });
  }

  public closePanel(panel: HTMLElement) {
    panel?.setAttribute('aria-modal', 'false');
    panel.inert = true;
    this.$utils.addOrRemoveClases('remove', 'open', panel);
  }
}
